import { useEffect, useCallback, useState } from 'react'
import {
  getUniquePresences,
  transformPropertyNames,
} from 'modules/presence/utils'
import { createPresencesChannels } from '../../createChannels'
import { Presence } from '../../types'
import { SocketChannels } from 'websockets/channels/SocketChannels'
import { useApolloClient } from '@apollo/react-hooks'
import ApolloClient from 'apollo-client'

let channelsGlobalRef: SocketChannels | undefined

export const initChannels = (apolloClient: ApolloClient<object>) => {
  if (!channelsGlobalRef) {
    channelsGlobalRef = createPresencesChannels(apolloClient)
  }
  return channelsGlobalRef
}

const PRESENCES_CHANNEL_PREFIX = 'presence-ro'

interface PresenceOptions {
  skip?: boolean
}

export const usePresences = (
  shareIdentifier: string,
  options: PresenceOptions = { skip: false }
) => {
  const apolloClient = useApolloClient()
  const [presences, setPresences] = useState<Presence[]>([])
  const [loading, setLoading] = useState(true)

  const channels = initChannels(apolloClient)

  const handlePresenceChange = useCallback(
    (response: { presences: Presence[] }) => {
      setLoading(false)
      setPresences(response.presences)
    },
    []
  )

  useEffect(() => {
    if (options.skip) {
      return
    }

    const channelName = `${PRESENCES_CHANNEL_PREFIX}:${shareIdentifier}`

    channels.join(channelName, 'presences', handlePresenceChange, {
      onClose: () => handlePresenceChange({ presences: [] }),
      onError: () => handlePresenceChange({ presences: [] }),
    })

    return () => {
      channels.leave(channelName, 'presences', handlePresenceChange)
    }
  }, [shareIdentifier, options.skip, handlePresenceChange, channels])

  return {
    loading,
    presences: transformPropertyNames(getUniquePresences(presences || [])),
  }
}
